import React from 'react'
import mary from '../images/team/mary.jpeg'
import basit from '../images/team/basit.jpg'
import onyeka from '../images/team/onyeka.jpeg'
import david from '../images/team/david.jpeg'
import cole from '../images/team/cole.jpeg'
import kamdel from '../images/team/kamdel.jpeg'
import sharon from '../images/team/sharon.jpeg'
import klinsman from '../images/team/klinsman.jpeg'
import nelson from '../images/team/nelson.jpeg'



export const ProfileData = [
    {
        fname: "Onyekachukwu",
        lName: "Ojumah",
        Image: onyeka,
        position: "Founder / CEO"
    },
    // {
    //     fname: "David",
    //     lName: "Oyelade",
    //     Image: david,
    //     position: "Co-Founder"
    // },
    {
        fname: "Ademuyiwa",
        lName: "Gbadebo",
        Image: cole,
        position: "Co-Founder"
    },
    {
        fname: "Sharon",
        lName: "Ogunnaike",
        Image: sharon,
        position: "Digital Marketer"
    },
    {
        fname: "Mary",
        lName: "Ogbe",
        Image: mary,
        position: "Product designer"
    },
    {
        fname: "Klinsman",
        lName: "Ikechuku",
        Image: klinsman,
        position: "Backend Developer"
    },
    {
        fname: "Jeremiah",
        lName: "Okunrintemi",
        Image: kamdel,
        position: "Graphic Designer"
    },
    {
        fname: "Basit",
        lName: "Animashaun",
        Image: basit,
        position: "Frontend Developer"
    },
    {
        fname: "Nelson",
        lName: "Nnamah",
        Image: nelson,
        position: "Motion Designer"
    }
    
]